<template>
  <div class="dialog-wrap">
    <el-dialog
      title="试卷编辑"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="780px"
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="100px"
      >
        <el-form-item
          label="年份："
          prop="year"
        >
          <el-date-picker
            v-model="dataForm.year"
            type="year"
            placeholder="选择年"
            value-format="yyyy"
          >
          </el-date-picker>

        </el-form-item>
        <!--       <el-form-item
          label="适合院校"
          prop="colleges"
        >
          <el-select
            v-model="dataForm.colleges"
            placeholder="请选择适合院校"
            filterable
            clearable
            @change="collegeChange"
            style="width:100%;"
          >
            <el-option
              v-for="(item,index) in collegeList"
              :key="index"
              :label="item.name"
              :value="{ value: item.code, label: item.name}"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="适合专业"
          prop="majors"
        >
          <el-select
            v-model="dataForm.majors"
            placeholder="请选择适合专业"
            @change="majorChange"
            clearable
            style="width:100%;"
          >
            <el-option
              v-for="(item,index) in majorList"
              :key="index"
              :label="item.name"
              :value="{ value: item.code, label: item.name}"
            >
              <span>{{ `（${item.code}）${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="适合科目"
          prop="subjects"
        >
          <el-select
            v-model="dataForm.subjects"
            placeholder="请选择适合科目"
            clearable
            style="width:100%;"
            @change="subjectsChange"
          >
            <el-option
              v-for="(item,index) in subjectsList"
              :key="index"
              :label="item.subject_name"
              :value="{ value: item.subject_code, label: item.subject_name}"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item
          label="适合科目："
          prop="subjects"
        >
          <div class="tag-wrap">
            <el-tag
              class="subject-item"
              size="medium"
              :key="item.id"
              v-for="item in subjects"
              closable
              :disable-transitions="false"
              @close="handleSubjectRemove(item)"
            >
              {{
                  item.college_name
                    ? `${item.college_name}-${item.name}`
                    : item.name
                    }}
            </el-tag>
            <el-button
              type="text"
              @click="handleSubjectChoose"
            >选择科目</el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="适合专业："
          prop="majors"
        >
          <div class="tag-wrap">
            <el-tag
              class="subject-item"
              size="medium"
              :key="item.id"
              v-for="item in majors"
              closable
              :disable-transitions="false"
              @close="handleMajorRemove(item)"
            >
              {{ `${item.name}/${item.code}` }}
            </el-tag>
            <el-button
              type="text"
              @click="handleMajorChoose"
            >选择专业</el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="适合院校："
          prop="colleges"
        >
          <div class="tag-wrap">
            <el-tag
              class="subject-item"
              size="medium"
              :key="item.id"
              v-for="item in colleges"
              closable
              :disable-transitions="false"
              @close="handleCollegeRemove(item)"
            >
              {{ `${item.name}` }}
            </el-tag>
            <el-button
              type="text"
              @click="handleCollegeChoose"
            >选择院校</el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="状态："
          prop="status"
        >
          <el-select
            v-model="dataForm.status"
            placeholder="请选择状态"
          >
            <el-option
              label="上线"
              value="1"
            >
            </el-option>
            <el-option
              label="下线"
              value="0"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>
    <SubjectChoose
      :visible="subjectChooseDialog"
      :subjects="subjects"
      @close="subjectChooseDialog = false"
      @submit="saveSubject"
    ></SubjectChoose>
    <MajorChoose
      :visible="majorChooseDialog"
      :majors="majors"
      @close="majorChooseDialog = false"
      @submit="saveMajor"
    ></MajorChoose>
    <CollegeChoose
      :visible="collegeChooseDialog"
      :colleges="colleges"
      @close="collegeChooseDialog = false"
      @submit="saveCollege"
    ></CollegeChoose>
  </div>
</template>

<script>
import MajorChoose from "@/components/dialog/major/MajorChoose";
import CollegeChoose from "@/components/dialog/college/CollegeChoose";
import SubjectChoose from "@/components/dialog/subject/SubjectChoose";
import { examPaperUpdate, exampaperlistUpdate } from '@/api/exam'
import { collegeList, collegeMajorList, majorSubjectList } from "@/api/common";


export default {
  components: {
    MajorChoose,
    CollegeChoose,
    SubjectChoose
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => { return [] }
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: this.content || {},
      rules: {
        name: [{ required: true, message: '请输入试卷名称', trigger: 'blur' }],
        status: [{ required: false, message: '请设置上线状态', trigger: 'change' }]
      },
      subjects: [],
      majors: [],
      colleges: [],
      subjectChooseDialog: false,
      majorChooseDialog: false,
      collegeChooseDialog: false,
      collegeList: [],
      majorList: [],
      subjectsList: [],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.fetchCollege()
      }
    },
    list(val) {
    }
  },
  methods: {
    fetchCollege() {
      collegeList({ isPaging: 0 }).then(res => {
        this.collegeList = res.list
      })
    },
    collegeChange(e) {
      this.dataForm.majors = {}
      this.dataForm.subjects = {}
      if (e) {
        this.getMajor(e.value);
      }
    },
    getMajor(college_code) {
      let query = {
        isPaging: 0,
        college_code: college_code,
      };
      collegeMajorList(query).then((res) => {
        this.majorList = res.list;
      });
    },
    majorChange(e) {
      this.dataForm.subjects = {}
      this.subjectsList = []
      if (e) {
        this.getSubjects(this.dataForm.colleges.value, e.value);
      }
      this.$forceUpdate()
    },
    getSubjects(college_code, major_code) {
      let query = {
        isPaging: 0,
        college_code: college_code,
        major_code: major_code,
      };
      majorSubjectList(query).then((res) => {
        this.subjectsList = res.list
      });
    },
    subjectsChange(e) {
      this.$forceUpdate()
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = {
            ids: this.list.map(v => { return v.id }),
            year: this.dataForm.year,
            subjects: this.subjects.map(v => {
              return {
                code: v.code,
                college_code: null,
              }
            }),
            majors: this.majors.map(v => {
              return {
                code: v.code,
                college_code: v.college_code ? v.college_code : null,
              }
            }),
            colleges: this.colleges.map(v => {
              return {
                code: v.code,
              }
            }),
            status: this.dataForm.status,
            /*       subjects: this.dataForm.subjects ? [{
                    code: this.dataForm.subjects.value,
                    college_code: null,
                  }] : null,
                  majors: this.dataForm.majors ? [{
                    code: this.dataForm.majors.value,
                    college_code: null,
                  }] : null,
                  colleges: this.dataForm.colleges ? [{
                    code: this.dataForm.colleges.value,
                  }] : null, */
          }
          if (!params.subjects.length) {
            delete params.subjects
          }
          if (!params.majors.length) {
            delete params.majors
          }
          if (!params.colleges.length) {
            delete params.colleges
          }
          if (!params.year) {
            delete params.year
          }
          if (!params.status) {
            delete params.status
          }

          exampaperlistUpdate(params).then(res => {
            this.$message.success(`更新成功`)

            this.$emit('submit', params)

            this.$refs['dataForm'].resetFields()
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },

    handleSubjectRemove(item) {
      this.subjects = this.subjects.filter((v) => v.id !== item.id);
    },
    handleSubjectChoose() {
      this.subjectChooseDialog = true;
    },
    saveSubject({ subjects }) {
      this.subjects = subjects;
    },
    handleMajorRemove(item) {
      this.majors = this.majors.filter((v) => v.id !== item.id);
    },
    handleMajorChoose() {
      this.majorChooseDialog = true;
    },
    saveMajor({ majors }) {
      this.majors = majors;
    },
    handleCollegeRemove(item) {
      this.colleges = this.colleges.filter((v) => v.id !== item.id);
    },
    handleCollegeChoose() {
      this.collegeChooseDialog = true;
    },
    saveCollege({ colleges }) {
      this.colleges = colleges;
    },
  }
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;

    .avatar-uploader /deep/ .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader /deep/ .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 128px;
      height: 128px;
      line-height: 128px;
      text-align: center;
    }
    .avatar {
      display: block;
      width: 128px;
      height: 128px;
      object-fit: cover;
    }
  }
}
.el-tag {
  margin: 5px;
}
</style>
